export enum ReportPage {
  Conversation,
  Meeting,
  Routing,
  Team,
  CoverageReport,
  Call,
  Automation,
  EmailPlaybook,
  SiteCoverage,
  Service,
  RealTime,
  ChatDetail,
  ChatOverview,
  RevenueOpportunities,
  SiteConcierge,
}

export const FEATURES_FOR_PAGE: Record<ReportPage, string[]> = {
  [ReportPage.Conversation]: [
    'my_conversations_reports',
    'org_conversations_reports',
  ],
  [ReportPage.Meeting]: [
    'my_conversations_reports',
    'org_conversations_reports',
  ],
  [ReportPage.Team]: ['my_conversations_reports', 'org_conversations_reports'],
  [ReportPage.Call]: ['my_conversations_reports', 'org_conversations_reports'],
  [ReportPage.Routing]: ['routing_reports'],
  [ReportPage.CoverageReport]: ['chat_playbook_reports'],
  [ReportPage.EmailPlaybook]: ['email_playbook_reports'],
  [ReportPage.Automation]: ['automation_reports'],
  [ReportPage.SiteCoverage]: ['chat_playbook_reports'],
  [ReportPage.Service]: ['service_reports'],
  [ReportPage.RealTime]: ['has_real_time_dashboard'],
  [ReportPage.ChatDetail]: [],
  [ReportPage.ChatOverview]: ['chat_playbook_reports'],
  [ReportPage.RevenueOpportunities]: [],
  [ReportPage.SiteConcierge]: [],
}

export interface Page {
  key?: number
  Component: any
  exact?: boolean
  path: string
  hasAccess: boolean | (() => boolean)
}
